import React from 'react';

function Footer() {
  return (
    <footer className='bg-light-alternate dark:bg-dark-alternate py-10'>
      <div className='container mx-auto px-4'>
        <div className='flex flex-col md:flex-row justify-between items-center'>
          <div className='mb-6 md:mb-0'>
            <h3 className='text-2xl font-bold text-primary-600 dark:text-primary-500 mb-2'>
              Red Panda Treehouse
            </h3>
            <p className='text-primary-700 dark:text-primary-400'>
              A welcoming space for red panda VTubers
            </p>
          </div>
          {/* <div className='flex space-x-6'>
            <a
              href='#'
              className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='currentColor'
                viewBox='0 0 24 24'
              >
                <path d='M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.72' />
              </svg>
            </a>
            <a
              href='#'
              className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='currentColor'
                viewBox='0 0 24 24'
              >
                <path d='M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385' />
              </svg>
            </a>
            <a
              href='#'
              className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='currentColor'
                viewBox='0 0 24 24'
              >
                <path d='M11.999 7.377a4.623 4.623 0 1 0 0 9.248 4.623 4.623 0 0 0 0-9.248zm0 7.627a3.004 3.004 0 1 1 0-6.008 3.004 3.004 0 0 1 0 6.008z' />
                <circle cx='16.806' cy='7.207' r='1.078' />
                <path d='M20.533 6.111A4.605 4.605 0 0 0 17.9 3.479a6.606 6.606 0 0 0-2.186-.42c-.' />
              </svg>
            </a>
          </div> */}
        </div>
        <div className='text-center mt-8'>
          <p className='text-light-text-muted dark:text-dark-text-muted'>
            © 2025 Red Panda Treehouse. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
